<template>
  <span
    :class="`fflag ff-${size}${flagId ? ` fflag-${flagId.toUpperCase()}` : ''}`"
    :style="background ? background : ''"
  ></span>
</template>

<script>
export default {
  name: "Flag",
  props: {
    flag: String,
    size: {
      type: String,
      default: "xs"
    }
  },
  data() {
    return {
      background: undefined
    };
  },
  methods: {
    setBackground() {
      this.background = `background: url(${
        this.flag
      }) no-repeat 50% 50% / cover`;
    }
  },
  computed: {
    flagId: function() {
      const fileName = this.flag
        .split("/")
        .pop()
        .split(".")[0];

      const langOnly = new RegExp(/^([a-z]{2})$/);
      const startsWithLang = new RegExp(/^([a-z]{2})(-|_)\w*$/);

      const lang =
        fileName.toLowerCase().match(langOnly) ||
        fileName.toLowerCase().match(startsWithLang);

      if (lang) {
        return lang[1];
      } else {
        this.setBackground();
        return undefined;
      }
    }
  }
};
</script>
